import { useMemo } from "react";

import {
  useAppProperties,
  useCollections,
  useVideos,
  useWatchlist,
} from "@/hooks";
import { ITEM_TYPE_COLLECTION, ITEM_TYPE_VIDEO } from "@/const.ts";
import { ItemType, WatchlistItem } from "@/api";
import { Header } from "@/app/modules/Navigation";
import { PageLoader } from "@/components";
import { cn, getTabIconFilename } from "@/utils";

import { PlaylistGrid } from "./components/PlaylistGrid.tsx";
import { useTranslate } from "@/providers/context";

export const WatchLater = () => {
  const { data, videoIds, collectionIds } = useWatchlist();
  const { watchlistLabel, isDarkMode } = useAppProperties();
  const { translate } = useTranslate();
  const noWatchlist = data?.Watchlist && data?.Watchlist.length === 0;

  const items = useMemo(() => {
    const items: { ChildId: string; Type: ItemType }[] = [];
    const watchlist: WatchlistItem[] = data?.Watchlist ?? [];
    for (const f of watchlist) {
      if ([ITEM_TYPE_VIDEO, ITEM_TYPE_COLLECTION].includes(f.ItemType)) {
        items.push({ ChildId: f.ItemId, Type: f.ItemType });
      }
    }
    return items;
  }, [data]);
  const { videoById } = useVideos({ ids: videoIds });
  const { collectionById } = useCollections({ ids: collectionIds });

  // Wait for the Watchlist -> Collections + Videos to load in
  const contentNotLoaded = !videoById || !collectionById;
  if (contentNotLoaded && !noWatchlist) {
    return <PageLoader />;
  }

  return (
    <div className="h-full px-7">
      <Header
        content={<div className="p1-bold">{translate(watchlistLabel)}</div>}
      />
      {contentNotLoaded || noWatchlist ? (
        <div className="flex h-4/5 w-full  items-center justify-center">
          <div className="flex w-[200px] flex-col items-center text-center">
            <img
              className={cn(isDarkMode && "invert")}
              height={68}
              width={68}
              alt="watchlist"
              src={getTabIconFilename({ icon: "watchlist.png" })}
            />
            <div className="h4-bold  mt-4">No {watchlistLabel}</div>
            <div className="p1 text-item-secondary mt-2">
              {translate("Looks like you haven't saved anything yet")}
            </div>
          </div>
        </div>
      ) : (
        <PlaylistGrid
          fullItems={{ videos: videoById, collections: collectionById }}
          items={items}
        />
      )}
    </div>
  );
};
